var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMatchedInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 182,
    viewBox: "0 0 181 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_28577)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.747 75.2891C117.134 89.6755 117.134 112.986 102.747 127.372C88.361 141.759 65.0505 141.759 50.6641 127.372",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 6.76056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6649 127.373C36.2784 112.987 36.2784 89.6763 50.6649 75.2899C65.0513 60.9034 88.3618 60.9034 102.748 75.2899",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 6.76056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.184 122.777L138.512 154.106",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 6.76056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.344 164.287L138.512 154.105",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 6.76056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.342 164.285L97 132.943",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 6.76056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.116 55.5879L90.8906 91.9942",
    stroke: "#F4F6F6",
    strokeWidth: 8.11191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8906 19.1992L157.116 55.5893",
    stroke: "#F4F6F6",
    strokeWidth: 8.11191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6602 55.5893L90.8858 19.1992",
    stroke: "#F4F6F6",
    strokeWidth: 8.11191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8858 91.9942L24.6602 55.5879",
    stroke: "#F4F6F6",
    strokeWidth: 8.11191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8858 114.953L24.6602 78.5625",
    stroke: "#F4F6F6",
    strokeWidth: 8.11191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.116 78.5625L90.8906 114.953",
    stroke: "#F4F6F6",
    strokeWidth: 8.11191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_28577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 182,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatchedInvoices);
export default __webpack_public_path__ + "static/media/no-matched-invoices.eeb74c9baecce11037a3cad521abd99d.svg";
export { ForwardRef as ReactComponent };